import { defineComponent, computed, watch, ref } from 'vue';
import { GraphChart } from '@hems/component';
import { getTodayConsumptionChartOptions } from '@hems/container/src/energyflow/value/energyIndendenceChartOptions';
import { createChartData, getFormattedNumberValue } from '@hems/container/src/energyflow/value/EnergyValueFunctions';
import { useLocale } from '@hems/util';
import { getBrowserTimezone } from '@hems/util/src/helper/dateHelper';
export default defineComponent({
    name: 'TodayConsumption',
    components: {
        GraphChart,
    },
    props: {
        reportData: {
            type: Object,
            required: true,
        },
        showChart: {
            type: Boolean,
            default: false,
        },
        timezone: {
            type: String,
            default: getBrowserTimezone(),
        },
    },
    setup(props) {
        const { intlFormatLocale } = useLocale();
        const chartData = ref([]);
        const todayConsumption = computed(() => getFormattedNumberValue(props.reportData?.con_kwh.origin ?? 0, intlFormatLocale.value));
        const options = computed(() => getTodayConsumptionChartOptions({ locale: intlFormatLocale.value, data: chartData.value }));
        watch([() => props.showChart, () => props.reportData], () => {
            if (props.reportData) {
                chartData.value = createChartData(todayConsumption.value.ori, props.reportData.con_data, props.reportData.colec_time, props.timezone);
            }
        });
        return {
            chartData,
            options,
            todayConsumption,
        };
    },
});
